import styled from "styled-components";

const Loading = ({ type = "" }) => {
  return (
    <Wrapper>
      <div className={type}>
        <div className="loader"></div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  /* HTML: <div class="loader"></div> */

  .section {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 80px;
  }

  .loader {
    width: 30px;
    aspect-ratio: 1;
    border-radius: 50%;
    border: 5px solid #fff;
    animation: l20-1 0.8s infinite linear alternate, l20-2 1.6s infinite linear;
  }
  .section .loader {
    width: 50px;
    border: 8px solid #000;
  }

  .icon .loader {
    width: 20px;
    border: 6px solid #000;
  }
  @keyframes l20-1 {
    0% {
      clip-path: polygon(50% 50%, 0 0, 50% 0%, 50% 0%, 50% 0%, 50% 0%, 50% 0%);
    }
    12.5% {
      clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 0%, 100% 0%, 100% 0%);
    }
    25% {
      clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 100% 100%, 100% 100%);
    }
    50% {
      clip-path: polygon(50% 50%, 0 0, 50% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%);
    }
    62.5% {
      clip-path: polygon(50% 50%, 100% 0, 100% 0%, 100% 0%, 100% 100%, 50% 100%, 0% 100%);
    }
    75% {
      clip-path: polygon(
        50% 50%,
        100% 100%,
        100% 100%,
        100% 100%,
        100% 100%,
        50% 100%,
        0% 100%
      );
    }
    100% {
      clip-path: polygon(
        50% 50%,
        50% 100%,
        50% 100%,
        50% 100%,
        50% 100%,
        50% 100%,
        0% 100%
      );
    }
  }
  @keyframes l20-2 {
    0% {
      transform: scaleY(1) rotate(0deg);
    }
    49.99% {
      transform: scaleY(1) rotate(135deg);
    }
    50% {
      transform: scaleY(-1) rotate(0deg);
    }
    100% {
      transform: scaleY(-1) rotate(-135deg);
    }
  }
`;

export default Loading;
